import { QESButton, QESSelect } from "@app/shared/qes-standards";
import { JSX, useEffect, useMemo, useState } from "react";
import { WafflesPaginationProps } from "./exports";

const WafflesPagination = (props: WafflesPaginationProps): JSX.Element => {
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [pageSize, setPageSize] = useState(props.recordsPerPage);
 
  useEffect(() => {
    if (props.totalRecords && props.recordsPerPage > 0) {
      const numberOfPages = Math.ceil(props.totalRecords / props.recordsPerPage);
      setMaxPage(numberOfPages);
    }
  }, [props.recordsPerPage, props.totalRecords]);

  useEffect(() => {
    if (!props.enableBackendPagination)
    {
      if (props.skip !== (page - 1) * props.recordsPerPage) {
        setPage((props.skip / props.recordsPerPage) + 1);
      }
    }
  }, [props.skip, props.enableBackendPagination]);

  useEffect(() => {
    if (props.resetToFirstPage){
      props.changePage(1);
      setPage(1);
    }
  }, [props?.resetToFirstPage]);

  const pageDropdownOptions = useMemo(() => {
    const options: JSX.Element[] = [];
    for (let i = 0; i < maxPage; i += 1) {
      options.push(<option value={i + 1} key={i + 1}>{i + 1}</option>);
    }
    return options;
  }, [props.recordsPerPage, props.totalRecords, maxPage]);

  const handlePageChange = (newPage: number) => {
    if (newPage < 1 || newPage > maxPage) {
      return false;
    }
    props.changePage(newPage);
    setPage(newPage);
  };

  const handlePageSizeChange = (recordsPerPage: number) => {
    setPageSize(recordsPerPage);
    //When the page size changes, reset to the first page
    setPage(1);
    props.handlePageSizeChange(recordsPerPage);
  };

  if (!props.enableBackendPagination && (!props.changePage || !props.recordsPerPage || !props.totalRecords || maxPage === 1)) {
    return null;
  }

  return (
    <div className={`waffles-pagination ${props.classNames}`}>
      <div className="waffles-pagination__content">
        <QESButton qesType="secondary" qesTestId="waffles-pagination__previous-page" onClick={() => handlePageChange(page - 1)} disabled={page <= 1}>Previous Page</QESButton>
        {(props.enableBackendPagination && props.showPageSizeSelector && props.handlePageSizeChange && props?.pageSizeOptions?.length > 0) &&
          <span className="waffles-pagination__pages">
            Showing {(
              <QESSelect
                label=""
                onChange={(e) => handlePageSizeChange(parseInt(e.target.value, 10))}
                testId="waffles-pagination__pages-select-page-size"
                value={pageSize}
              >
                {props.pageSizeOptions.map(option => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </QESSelect>
            
            )}
          </span>
        }
        <span className="waffles-pagination__pages">
          Page {(
            <>
              <QESSelect
                className="waffles-pagination__selector"
                hideLabel={true}
                label=""
                onChange={(e) => handlePageChange(parseInt(e.target.value, 10))}
                testId="waffles-pagination__pages-select"
                value={page}
              >
                {pageDropdownOptions}
              </QESSelect>
            </>
          )}
          of {Math.ceil(props.totalRecords / props.recordsPerPage)}
        </span>
        <QESButton qesType="secondary" qesTestId="waffles-pagination__next-page" onClick={() => handlePageChange(page + 1)} disabled={page >= maxPage}>Next Page</QESButton>
      </div>
    </div>
  );
};

export default WafflesPagination;
